import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Router, ActivatedRoute, NavigationStart, Event as NavigationEvent } from "@angular/router";
import { AuthService } from '../_services/auth.service';
import { PlatformLocation } from '@angular/common'
import { filter } from 'rxjs/operators';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'dashboardcallback',
  templateUrl: './dashboardcall.component.html'
})
export class DashboardCallbackComponent implements OnInit {

  profile: any;

  isLoggedout: any;
  isSessionNew: any;
  isNewArrival: any;
  isAuthLoginReached: any;

  previousUrl: any[];

  constructor(private http: HttpClient, private router: Router, private auth: AuthService, private activatedRoute: ActivatedRoute
    , privatelocation: PlatformLocation, private spinnerService: Ng4LoadingSpinnerService) {
        this.spinnerService.show();
  }

  ngOnInit() {
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      this.router.navigate(['/home']);
    } else {
      this.viewDashboardlist();
    }
  }

  async viewDashboardlist() {
      await this.auth.GetAccessConfigDetails();
  }
}